window.CGA = {
	
	subscribe : function(){
		MyWindow.alert('Votre abonnement est terminé, contactez votre CGA.');
	}

};